import { useState } from "react";
import { Pencil } from "lucide-react";
import { useSite } from "../lib/site";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import BrandingForm from "./admin/BrandingForm";

// Small admin-only pencil that opens the site branding editor.
export default function EditPencil({ section = "all", testid, className = "" }) {
  const { canEdit } = useSite();
  const [open, setOpen] = useState(false);
  if (!canEdit) return null;
  return (
    <>
      <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }} title="Edit" aria-label="Edit"
        className={`w-5 h-5 shrink-0 rounded-full bg-[#D4AF37] text-black flex items-center justify-center shadow hover:scale-110 transition-transform ${className}`} data-testid={testid}>
        <Pencil className="w-2.5 h-2.5" />
      </button>
      {open && (
        <Dialog open onOpenChange={(o) => !o && setOpen(false)}>
          <DialogContent className="bg-[#111319] border-[#D4AF37]/30 text-white sm:max-w-2xl max-h-[92vh] overflow-y-auto" data-testid="branding-dialog">
            <DialogHeader><DialogTitle className="font-display text-3xl gold-text">Edit site branding</DialogTitle></DialogHeader>
            <BrandingForm section={section} onDone={() => setOpen(false)} />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
